<template>
    <ul class="list">
        <li
            v-for="(item, columnKey) in data.links"
            :key="columnKey"
            class="item"
        >
            <CmsLink
                class="footer-menu-item-link"
                :link="item.link"
            />
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { FooterItemLinkListFragment } from '@/graphql/api'

import CmsLink from '@/components/cms/CmsLink.vue'

defineProps<{
    data: FooterItemLinkListFragment
}>()
</script>

<style lang="scss" scoped>
.list {
    margin: 0;
    padding: 0 0 20px;

    .list {
        display: block;
        line-height: 25px;
    }

    .footer-menu-item-link {
        cursor: pointer;
    }
}
</style>
